import { useState } from 'react';
import { SubmitHandler } from 'react-hook-form';
import { Button } from '@givebutter/primitives/button';
import { PledgeForm } from 'assets/js/pages/pledges/PledgeForm';
import { useCreatePledge } from 'assets/js/pages/pledges/useCreatePledge';
import { useInstallmentAutoRecalculate } from 'assets/js/pages/pledges/useInstallmentCalculation';
import { PledgeFormValue, usePledgeForm } from 'assets/js/pages/pledges/usePledgeForm';
import { useDialogRoute } from 'components/dialog-route/DialogRouteContext';
import * as Drawer from 'components/drawer';
import * as Form from 'components/form';

const AddPledgeDrawer = () => {
    const { goBack } = useDialogRoute();
    const methods = usePledgeForm();
    const [saveAndExit, setSaveAndExit] = useState(false);
    const { handleSubmit, setError, resetFormButton, reset } = methods;
    useInstallmentAutoRecalculate(methods);

    const { mutate: submit, isPending: isSubmitting } = useCreatePledge({
        setError,
        onSuccess: () => {
            if (saveAndExit) {
                goBack();
            } else {
                reset();
            }
        },
        onError: () => {
            resetFormButton();
        },
    });

    return (
        <Form.Provider {...methods}>
            <form
                className={'contents'}
                onSubmit={handleSubmit(submit as SubmitHandler<PledgeFormValue>)}
            >
                <Drawer.Header>
                    <Drawer.Title>New pledge</Drawer.Title>
                    <Drawer.Close />
                </Drawer.Header>
                <Drawer.Body className="flex flex-col gap-6">
                    <PledgeForm />
                </Drawer.Body>
                <Drawer.Footer>
                    <div
                        className={
                            'flex w-full flex-wrap-reverse items-center justify-between gap-2'
                        }
                    >
                        <Drawer.Cancel asChild={true}>
                            <Button variant="transparent">Cancel</Button>
                        </Drawer.Cancel>
                        <div className={'flex flex-wrap-reverse items-center gap-4'}>
                            <Form.SubmitButton
                                variant={'outline'}
                                color={'neutral'}
                                noAnimation={true}
                                onClick={() => setSaveAndExit(false)}
                                isSubmitting={isSubmitting}
                            >
                                Save and add another
                            </Form.SubmitButton>
                            <Form.SubmitButton
                                onClick={() => setSaveAndExit(true)}
                                isSubmitting={isSubmitting}
                            >
                                Save
                            </Form.SubmitButton>
                        </div>
                    </div>
                </Drawer.Footer>
            </form>
        </Form.Provider>
    );
};

export { AddPledgeDrawer };
